import { FormationLight, FormationSummary } from '@wwf/sdk';
import { Box, Link, Typography } from '@mui/material';
import { useRecordContext } from 'react-admin';
import { FormationAvatar } from './FormationAvatar';
import { useFormationDrawer } from '../drawer/FormationDrawer';

export const FormationLightCard = (props: {
    record?: FormationLight | FormationSummary;
    noLink?: boolean;
}) => {
    const record = useRecordContext<FormationLight | FormationSummary>(props);
    const { openDrawer } = useFormationDrawer();

    const content = (
        <Box display="flex" alignItems="center" gap={0.5}>
            <FormationAvatar variant="sm" record={record} />
            <Typography variant="body2" noWrap>
                {record?.name}
            </Typography>
        </Box>
    );

    if (props.noLink) return content;

    if (record?.id != null) {
        return (
            <Link
                component="button"
                variant="body2"
                onClick={() => openDrawer('show', record.id)}
                sx={{
                    cursor: 'pointer',
                    textAlign: 'left',
                    border: 0,
                    background: 'none',
                    padding: 0,
                    font: 'inherit',
                }}
            >
                {content}
            </Link>
        );
    }

    return content;
};
